import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/public/Reveal";

// Editorial section header: giant faded number behind a two-line poster title.
export default function SectionHeader({ number, label, title, titleGreen, link, linkLabel = "See all" }) {
  return (
    <div className="relative mb-10">
      {number && (
        <span aria-hidden="true" className="pointer-events-none select-none absolute -top-10 lg:-top-16 -left-2 font-poster text-stroke text-[6rem] lg:text-[11rem] leading-none opacity-60">{number}</span>
      )}
      <div className="relative flex items-end justify-between gap-6">
        <Reveal>
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="w-6 h-0.5 bg-brand" />
              <span className="label-mono">{label}</span>
            </div>
            <h2 className="font-poster text-white uppercase leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
              {title} {titleGreen && <span className="text-brand">{titleGreen}</span>}
            </h2>
          </div>
        </Reveal>
        {link && (
          <Link to={link} className="hidden sm:inline-flex items-center gap-1.5 font-cond font-bold uppercase tracking-wider text-white/80 hover:text-brand transition-colors shrink-0 group">
            {linkLabel} <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        )}
      </div>
    </div>
  );
}
